<script lang="jsx">
import { h, ref, onMounted, onUnmounted } from "vue";
import { closeSidebar } from "../layouts";
import { signalsApi } from "@/api/signals";
import Bus from "@/core/bus";

export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      signalsCount: 0,
      intervalId: null,
    };
  },

  mounted() {
    this.updateSignalsCount();
    // Обновляем каждые 30 секунд
    this.intervalId = setInterval(() => this.updateSignalsCount(), 30000);

    // Подписываемся на событие сохранения данных для обновления счетчика
    Bus.$on("save-data", this.onSaveData);
    this.setActiveByRoute(this.items, this.$route.path);
  },

  beforeUnmount() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    // Отписываемся от события
    Bus.$off("save-data", this.onSaveData);
  },

  watch: {
    "$route.path"(path) {
      this.clearActive(this.items);
      this.setActiveByRoute(this.items, path);
    },
  },

  computed: {
    path() {
      return this.$route.path;
    },
  },

  methods: {
    async updateSignalsCount() {
      try {
        const count = await signalsApi.getActiveCount();
        this.signalsCount = typeof count === "number" ? count : 0;
      } catch (error) {
        console.error("Ошибка при получении количества уведомлений:", error);
        this.signalsCount = 0;
      }
    },
    onSaveData(saveData) {
      // Обновляем счетчик при сохранении записи из таблицы signals
      if (saveData.table === "signals") {
        this.updateSignalsCount();
      }
    },

    clearActive(items) {
      items.forEach((item) => {
        item.active = false;
        if (item.items) {
          this.clearActive(item.items);
        }
      });
    },

    setActive(items, path) {
      let active = false;

      for (const item of items) {
        item.active = false;

        if (item.route == path) {
          item.active = true;

          active = true;

          break;
        }

        if (item.items && item.items.length > 0) {
          if (this.setActive(item.items, path)) {
            item.active = true;
            active = true;

            break;
          }
        }
      }

      return active;
    },

    setActiveByRoute(items, path) {
      for (const item of items) {
        if (item.route === path) {
          item.active = true;
          return true;
        }

        if (item.items && this.setActiveByRoute(item.items, path)) {
          item.active = true;
          item.open = true;

          return true;
        }
      }
      return false;
    },


    onClick(e, item) {
      e.preventDefault();

      if (item.items && item.items.length > 0) {
        item.open = !item.open;
      }

      if (item.route) {
        if (this.$route.path !== item.route) {
          this.$router.push(item.route);

          if (!item.items || item.items.length === 0) {
            closeSidebar();
          }

          
        }
        if (item.route === "/signals") {
            this.updateSignalsCount();
          }
      }
    },

    link(item) {
      const { header, title, icon, route, active = false } = item;
      const children = [h("i", { class: icon }), h("span", header)];

      // Добавляем бейдж для пункта "Сигналы"
      if (route === "/signals") {
        if (this.signalsCount > 0) {
          children.push(
            h(
              "span",
              {
                class: "badge badge-pill bg-danger ml-auto",
                style: { "margin-left": "auto" },
              },
              this.signalsCount.toString(),
            ),
          );
        }
      }

      return h(
        "a",
        {
          class: { "nav-link": true, active: item.active },
          title: title ? title : header,
          href: route ? route : "#",
          onClick: (e) => this.onClick(e, item),
        },
        children,
      );
    },

    menuItems(items) {
      return items.map((item) => {
        const elements = [this.link(item)];

        if (item.items && item.open) {
          elements.push(
            h(
              "ul",
              {
                class: "nav nav-group-sub",
                style: "display: block;",
              },
              this.menuItems(item.items),
            ),
          );
        }

        return h(
          "li",
          {
            class: [
              "nav-item",
              item.items ? "nav-item-submenu" : "",
              item.open ? "nav-item-open" : "",
            ],
          },
          elements,
        );
      });
    },
  },

  render() {
    const menus = [];

    for (const item of this.items) {
      if (item.header)
        menus.push(
          <li class="nav-item-header">
            <div class="text-uppercase font-size-xs line-height-xs">
              {item.header}
            </div>
            <i class="icon icon-more-horizontal" title="Main"></i>
          </li>,
        );
      menus.push(this.menuItems(item.items));
    }

    return h("ul", { class: "nav nav-sidebar" }, menus);
  },
};
</script>

<style></style>
